module.exports = __webpack_public_path__ + "2f4a6a9d425e9d9fad271a34ba9ad94e.fnt";